module.exports = __webpack_public_path__ + "static/img/蒙版组 269@2x.8cf29e41.png";